import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import type { CoverageRule } from '@/shared/types';

const PROPERTY_COVERAGES_QUERY_KEY = 'propertyCoverages';

export const useHasCustomScreeningStatusLabels = (isSmbInvites: boolean) => {
  const queryClient = useQueryClient();

  return useCallback(
    (propertyId?: string | null) => {
      if (isSmbInvites || !propertyId) return false;

      const coverageRulesQueryKey = [PROPERTY_COVERAGES_QUERY_KEY, propertyId];
      const coverageRulesQueryState =
        queryClient.getQueryState<CoverageRule[]>(coverageRulesQueryKey);

      if (coverageRulesQueryState?.status === 'error') {
        return false;
      }

      const coverageRulesFromApi =
        queryClient.getQueryData<CoverageRule[]>(coverageRulesQueryKey) ?? [];

      return coverageRulesFromApi.length > 0;
    },
    [isSmbInvites, queryClient],
  );
};
